
import { mapGetters } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import moment from "moment";
import Plus from "vue-material-design-icons/Plus.vue";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import SwapHorizontal from "vue-material-design-icons/SwapHorizontal.vue";
import FileExcel from "vue-material-design-icons/FileExcel.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "app-movimentacao-banco",
  mixins: [SistemaMixin],
  data() {
    return {
      banco: null,
      titulo: null,
      movimentacoes: [],
      data_inicial: null,
      data_final: null,
      titulo_card: null,
      fields: [
        {
          key: "data_hora",
          label: "Data/Hora",
          sortable: false,
          thClass: "text-left align-middle coluna-data-extrato",
          tdClass: "text-left align-middle coluna-data-extrato",
        },
        {
          key: "tipo_extrato",
          label: "Tipo / status",
          sortable: false,
          thClass: "text-left align-middle coluna-marcadores-extrato",
          tdClass: "text-left align-middle coluna-marcadores-extrato",
        },
        {
          key: "descricao",
          label: "Descrição",
          sortable: false,
          thClass: "text-left align-middle",
          tdClass: "text-left align-middle",
        },
        {
          key: "origem",
          label: "Origem",
          sortable: false,
          thClass: "text-left align-middle",
          tdClass: "text-left align-middle",
        },
        {
          key: "destino",
          label: "Destino",
          sortable: false,
          thClass: "text-left align-middle",
          tdClass: "text-left align-middle",
        },
        {
          key: "valor_movimento",
          label: "Valor",
          sortable: false,
          thClass: "text-right align-middle",
          tdClass: "text-right align-middle",
        },
        {
          key: "saldo_apos",
          label: "Saldo após",
          sortable: false,
          thClass: "text-right align-middle",
          tdClass: "text-right align-middle",
        },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thStyle: { width: "120px" },
          thClass: "text-center align-middle coluna-acoes-extrato",
          tdClass: "text-center align-middle coluna-acoes-extrato",
        },
      ],
      isLoading: true,
      selectedPeriodo: "mes",
      periodos: [
        { value: "hoje", text: "Hoje" },
        { value: "ontem", text: "Ontem" },
        { value: "semana", text: "7 dias" },
        { value: "semana_passada", text: "Semana passada" },
        { value: "mes", text: "Este mês" },
        { value: "personalizado", text: "Personalizado" },
      ],
      filtroTipo: "Todos",
      tiposFiltro: ["Todos", "Entrada", "Saída", "Transferência", "Estorno"],
      filtroStatus: "Todos",
      statusFiltro: ["Todos", "Ativa", "Estornada"],
      buscaMovimentoInput: "",
      buscaMovimento: "",
      debounceBuscaTimer: null,
      paginaAtual: 1,
      porPagina: 50,
      opcoesPorPagina: [
        { value: 20, text: "20 por página" },
        { value: 50, text: "50 por página" },
        { value: 100, text: "100 por página" },
      ],
      lancamento: {},
      dataMovimentoOriginalEdicao: null,
      configMoney: settingMoney,
      tiposMovimento: [
        { id: 2, descricao: "Saída" },
        { id: 1, descricao: "Entrada" },
      ],
      bancos: [],
      transferencia: {
        banco: null,
        valor: 0,
        data_transferencia: moment().format("YYYY-MM-DD"),
        observacao: "",
      },
      tipoTransferencia: "contas",
      mostrarTransferencia: false,
      isSavingTransferenciaContas: false,
      isSavingTransferenciaCaixa: false,
      isAtualizandoBanco: false,
      erroTransferenciaCaixa: "",
      transferenciaCaixaPendenteAtualizacao: null,
      isEstornandoTransferenciaCaixa: null,
      saldoAnteriorPeriodo: null,
      dataSaldoAnteriorPeriodo: null,
      alturaUtilExtrato: null,
    };
  },
  components: {
    Plus,
    Money,
    SwapHorizontal,
    FileExcel,
  },
  watch: {
    buscaMovimentoInput(valor) {
      clearTimeout(this.debounceBuscaTimer);
      this.debounceBuscaTimer = setTimeout(() => {
        this.buscaMovimento = valor;
        this.reiniciarPaginacao();
      }, 400);
    },
    filtroTipo() {
      this.reiniciarPaginacao();
    },
    filtroStatus() {
      this.reiniciarPaginacao();
    },
    porPagina() {
      this.reiniciarPaginacao();
    },
    paginaAtual() {
      this.resetarScrollTabela();
    },
    totalPaginas(valor) {
      if (this.paginaAtual > valor) {
        this.paginaAtual = valor;
      }
    },
  },
  methods: {
    atualizarAlturaUtilExtrato() {
      this.$nextTick(() => {
        const pagina = this.$refs.paginaExtrato;
        if (!pagina) return;

        const footerSistema = document.getElementById("kt_footer");
        const contentSistema = document.getElementById("kt_content");
        const paddingInferior = contentSistema
          ? Number.parseFloat(
              window.getComputedStyle(contentSistema).paddingBottom
            ) || 0
          : 0;
        const alturaFooter = footerSistema
          ? footerSistema.getBoundingClientRect().height
          : 0;
        const topoPagina = Math.max(0, pagina.getBoundingClientRect().top);
        const alturaDisponivel = Math.floor(
          window.innerHeight - topoPagina - alturaFooter - paddingInferior
        );

        this.alturaUtilExtrato = `${Math.max(0, alturaDisponivel)}px`;
      });
    },
    resetarScrollTabela() {
      this.$nextTick(() => {
        const areaRolavel = this.$el?.querySelector(
          ".bloco-tabela-extrato .table-responsive"
        );
        if (areaRolavel) areaRolavel.scrollTop = 0;
      });
    },
    reiniciarPaginacao() {
      this.paginaAtual = 1;
      this.resetarScrollTabela();
    },
    dataAberturaConta(banco) {
      if (!banco?.created_at || !moment(banco.created_at).isValid())
        return null;

      return moment(banco.created_at).format("YYYY-MM-DD");
    },
    dataMaisRecente(...datas) {
      return datas.filter(Boolean).sort().pop() || null;
    },
    dataAnteriorAbertura(data, dataMinima) {
      const dataInformada = moment(data, "YYYY-MM-DD", true);

      return (
        Boolean(dataMinima) &&
        dataInformada.isValid() &&
        dataInformada.isBefore(dataMinima, "day")
      );
    },
    parametrosExtrato(inicio = this.data_inicial, fim = this.data_final) {
      return {
        id_banco: this.$route.params.id_banco,
        data_inicial: inicio,
        data_final: fim,
        com_resumo_saldo: true,
      };
    },
    aplicarRespostaExtrato(data) {
      const respostaEstruturada = !Array.isArray(data) && data;
      const movimentacoes = respostaEstruturada
        ? data.movimentacoes || []
        : data || [];

      this.movimentacoes = movimentacoes;
      this.saldoAnteriorPeriodo = respostaEstruturada
        ? Number(data.saldo_anterior) || 0
        : movimentacoes.length
        ? Number(movimentacoes[0].saldo_dia_anterior) || 0
        : 0;
      this.dataSaldoAnteriorPeriodo = respostaEstruturada
        ? data.data_saldo_anterior || null
        : movimentacoes[0]?.data_saldo_dia_anterior || null;
    },
    async carregarBancoAtual() {
      const { data } = await this.$http.post("/bancos/find", {
        id_banco: this.$route.params.id_banco,
      });
      this.banco = data;

      return data;
    },
    async carregarBancoEExtrato(
      inicio = this.data_inicial,
      fim = this.data_final
    ) {
      const [banco, extrato] = await Promise.all([
        this.$http.post("/bancos/find", {
          id_banco: this.$route.params.id_banco,
        }),
        this.$http.post(
          "/bancos/movimentacoes",
          this.parametrosExtrato(inicio, fim)
        ),
      ]);

      this.banco = banco.data;
      this.aplicarRespostaExtrato(extrato.data);
    },
    ehTransferenciaBancoCaixa(item) {
      return Number(item?.transferencia_banco_caixa) === 1;
    },
    ehEstornoTransferenciaBancoCaixa(item) {
      return Number(item?.transferencia_banco_caixa_estorno) === 1;
    },
    ehTransferenciaBancoCaixaEstornada(item) {
      return Number(item?.transferencia_banco_caixa_estornada) === 1;
    },
    podeEstornarTransferenciaBancoCaixa(item) {
      return item?.pode_estornar === true;
    },
    podeEditarMovimento(item) {
      return item?.pode_editar === true;
    },
    tipoMovimento(item) {
      return (
        item?.tipo_extrato ||
        (Number(item?.tipo_movimento) === 1 ? "Entrada" : "Saída")
      );
    },
    statusMovimento(item) {
      return (
        item?.status_extrato ||
        (this.ehTransferenciaBancoCaixaEstornada(item) ? "Estornada" : "Ativa")
      );
    },
    siglaTipo(item) {
      return (
        {
          Entrada: "E",
          Saída: "S",
          Transferência: "T",
          Estorno: "R",
        }[this.tipoMovimento(item)] || "?"
      );
    },
    siglaStatus(item) {
      return this.statusMovimento(item) === "Estornada" ? "E" : "A";
    },
    classeTipo(item) {
      return `badge-tipo--${this.tipoMovimento(item)
        .toLowerCase()
        .replace("ê", "e")
        .replace("í", "i")}`;
    },
    classeStatus(item) {
      return this.statusMovimento(item) === "Estornada"
        ? "badge-status--estornada"
        : "badge-status--ativa";
    },
    detalheMovimento(item) {
      const documento =
        item.documento_conta_receber || item.documento_conta_pagar;
      const historico =
        item.historico_conta_receber || item.historico_conta_pagar;

      return [documento, historico].filter(Boolean).join(" · ");
    },
    descricaoApresentacao(item) {
      return String(item?.descricao || "").replace(
        /Movimento do Caixa/gi,
        "Caixa"
      );
    },
    classeLinhaExtrato(item) {
      return item?.eh_fechamento_diario ? "linha-fechamento-diario" : "";
    },
    dataHoraEfetivaMovimento(item) {
      if (item?.data_hora_efetiva) return item.data_hora_efetiva;
      if (!item?.data_movimento) return "";

      const dataMovimento = moment(item.data_movimento);
      if (!dataMovimento.isValid()) return "";
      if (dataMovimento.format("HH:mm:ss") !== "00:00:00") {
        return dataMovimento.format("YYYY-MM-DD HH:mm:ss");
      }

      const criadoEm = moment(item.criado_em);
      if (
        criadoEm.isValid() &&
        criadoEm.format("YYYY-MM-DD") === dataMovimento.format("YYYY-MM-DD")
      ) {
        return criadoEm.format("YYYY-MM-DD HH:mm:ss");
      }

      return dataMovimento.format("YYYY-MM-DD");
    },
    formatDataHoraMovimento(item) {
      const dataHoraEfetiva = this.dataHoraEfetivaMovimento(item);
      if (!dataHoraEfetiva) return "—";

      const formato =
        dataHoraEfetiva.length > 10 ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY";
      return moment(dataHoraEfetiva).format(formato);
    },
    async estornarTransferenciaCaixa(item) {
      if (item?.pode_estornar !== true || this.isEstornandoTransferenciaCaixa !== null) return;
      if (item?.origem_movimento && item.origem_movimento !== "transferencia_banco_caixa") {
        if (["conta_receber", "conta_pagar"].includes(item.origem_movimento)) {
          return this.getRequestAdmin(() => this.estornarMovimentoOrigem(item));
        }
        return this.estornarMovimentoOrigem(item);
      }
      if (
        this.isEstornandoTransferenciaCaixa !== null ||
        !this.podeEstornarTransferenciaBancoCaixa(item) ||
        !item.id_financeiro
      )
        return;

      this.isEstornandoTransferenciaCaixa = item.id_financeiro;
      let estornoConfirmado = false;

      try {
        const resultado = await this.$swal.fire({
          icon: "warning",
          title: "Estornar transferência?",
          text: `Confirma o estorno da transferência de R$ ${this.numberToReal(
            item.valor_movimento
          )} para o Caixa? O valor retornará ao banco e será registrada uma saída compensatória no Caixa.`,
          showCancelButton: true,
          confirmButtonText: "Estornar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#f64e60",
        });

        if (!resultado.isConfirmed) return;

        await this.$http.post(
          `/financeiro/transferencia-banco-caixa/${item.id_financeiro}/estornar`
        );
        estornoConfirmado = true;
        this.$toast.success("Transferência estornada com sucesso!");

        await this.carregarBancoEExtrato();
      } catch (error) {
        if (estornoConfirmado) {
          this.$toast.warning(
            "A transferência foi estornada, mas não foi possível atualizar o saldo e o extrato. Atualize a tela."
          );
        } else if (!error.response) {
          this.$toast.error("Não foi possível estornar a transferência.");
        }
      } finally {
        this.isEstornandoTransferenciaCaixa = null;
      }
    },
    async estornarMovimentoOrigem(item) {
      if (
        this.isEstornandoTransferenciaCaixa !== null ||
        item?.pode_estornar !== true
      ) return;
      const rotas = {
        transferencia_banco_banco: [
          "/bancos/transferencia-estornar",
          { id_movimento: item.id_movimento },
        ],
        conta_receber: [
          "/contareceber/estornar",
          { contas_receber: [{ id: item.id_conta_receber }] },
        ],
        conta_pagar: [
          "/contapagar/estornar",
          { contas_pagar: [{ id: item.id_conta_pagar }] },
        ],
      };
      const rota = rotas[item.origem_movimento];
      if (!rota) return;
      this.isEstornandoTransferenciaCaixa = item.id_financeiro || item.id_movimento;
      let confirmado = false;
      try {
        const resposta = await this.$swal.fire({
          icon: "warning",
          title: "Estornar movimentação?",
          text: "A operação de origem será estornada, incluindo seus efeitos financeiros.",
          showCancelButton: true,
          confirmButtonText: "Estornar",
          cancelButtonText: "Cancelar",
        });
        if (!resposta.isConfirmed) return;
        const { data } = await this.$http.post(...rota);
        if (data?.status === false) {
          this.$toast.error(data.msg || "Não foi possível estornar a operação.");
          return;
        }
        confirmado = true;
        this.$toast.success("Operação estornada com sucesso!");
        await this.carregarBancoEExtrato();
      } catch (error) {
        if (confirmado) {
          this.$toast.warning(
            "Operação estornada, mas não foi possível atualizar o extrato. Atualize a tela."
          );
        } else {
          this.$toast.error(
            error?.response?.data?.msg || "Não foi possível estornar a operação."
          );
        }
      } finally {
        this.isEstornandoTransferenciaCaixa = null;
      }
    },
    async abrirTransferencia() {
      if (
        !this.banco ||
        this.isAtualizandoBanco ||
        this.isSavingTransferencia ||
        this.transferenciaCaixaPendenteAtualizacao
      )
        return;

      this.isAtualizandoBanco = true;
      try {
        await this.carregarBancoAtual();
        const hoje = moment().format("YYYY-MM-DD");
        this.transferencia = {
          ...this.transferencia,
          data_transferencia: hoje,
        };
        this.mostrarTransferencia = true;
      } catch (error) {
        this.$toast.error("Não foi possível atualizar o saldo da conta.");
      } finally {
        this.isAtualizandoBanco = false;
      }
    },
    selecionarTipoTransferencia(tipo) {
      if (this.tipoTransferencia === tipo) return;

      if (tipo === "caixa") {
        this.transferencia = {
          ...this.transferencia,
          banco: null,
        };
      }
      this.erroTransferenciaCaixa = "";
      this.tipoTransferencia = tipo;
    },
    selecionarTransferenciaCaixa() {
      this.selecionarTipoTransferencia("caixa");
    },
    async abrirTransferenciaCaixa() {
      await this.abrirTransferencia();
      if (!this.mostrarTransferencia) return;

      this.selecionarTransferenciaCaixa();
    },
    salvarTransferenciaAtual() {
      return this.tipoTransferencia === "caixa"
        ? this.salvarTransferenciaCaixa()
        : this.salvarTransferencia();
    },
    async salvarTransferenciaCaixa() {
      // O guard é síncrono: bloqueia outro submit antes da atualização visual do botão.
      if (
        this.isSavingTransferenciaCaixa ||
        this.transferenciaCaixaPendenteAtualizacao
      )
        return;

      const valor = Number(this.transferencia.valor);
      const dataTransferencia = this.transferencia.data_transferencia;
      const descricao = this.transferencia.observacao || "";
      this.erroTransferenciaCaixa = "";

      if (!this.banco?.id_banco) {
        this.erroTransferenciaCaixa = "Conta bancária não encontrada.";
      } else if (!Number.isFinite(valor) || valor <= 0) {
        this.erroTransferenciaCaixa = "Informe um valor maior que zero.";
      } else if (!moment(dataTransferencia, "YYYY-MM-DD", true).isValid()) {
        this.erroTransferenciaCaixa = "Informe uma data válida.";
      } else if (
        this.dataAnteriorAbertura(dataTransferencia, this.dataMinimaBancoAtual)
      ) {
        this.erroTransferenciaCaixa =
          "A data da movimentação não pode ser anterior à abertura da conta.";
      } else if (descricao.length > 140) {
        this.erroTransferenciaCaixa =
          "A observação deve possuir no máximo 140 caracteres.";
      }
      if (this.erroTransferenciaCaixa) return;

      this.isSavingTransferenciaCaixa = true;
      try {
        await this.$http.post("/financeiro/transferencia-banco-caixa", {
          id_banco: this.banco.id_banco,
          valor,
          data_transferencia: dataTransferencia,
          descricao,
        });
        this.transferenciaCaixaPendenteAtualizacao = dataTransferencia;
        this.mostrarTransferencia = false;
        this.transferencia = {
          banco: null,
          valor: 0,
          data_transferencia: moment().format("YYYY-MM-DD"),
          observacao: "",
        };
        this.$toast.success(
          "Transferência para o Caixa realizada com sucesso!"
        );
        await this.atualizarExtratoTransferenciaCaixa();
      } catch (error) {
        const status = error.response?.status;
        const errors = error.response?.data?.errors;
        if (status === 422) {
          this.erroTransferenciaCaixa = errors?.id_banco
            ? "Conta bancária não encontrada."
            : Object.values(errors || {})
                .flat()
                .join(" ") || "Verifique os dados da transferência.";
        } else if (status === 401) {
          this.erroTransferenciaCaixa =
            "Sua sessão expirou. Entre novamente para continuar.";
        } else if (status === 403) {
          this.erroTransferenciaCaixa =
            "Você não tem permissão para realizar esta transferência.";
        } else {
          this.erroTransferenciaCaixa =
            "Não foi possível confirmar a transferência. Confira o extrato antes de tentar novamente.";
        }
      } finally {
        this.isSavingTransferenciaCaixa = false;
      }
    },
    async atualizarExtratoTransferenciaCaixa() {
      const dataTransferencia = this.transferenciaCaixaPendenteAtualizacao;
      if (!dataTransferencia || this.isLoading) return;
      this.isLoading = true;
      // Inclui a nova saída mesmo quando a data escolhida está fora do filtro atual.
      const inicio =
        this.data_inicial && this.data_inicial < dataTransferencia
          ? this.data_inicial
          : dataTransferencia;
      const fim =
        this.data_final && this.data_final > dataTransferencia
          ? this.data_final
          : dataTransferencia;
      try {
        await this.carregarBancoEExtrato(inicio, fim);
        if (inicio !== this.data_inicial || fim !== this.data_final) {
          this.selectedPeriodo = "personalizado";
        }
        this.data_inicial = inicio;
        this.data_final = fim;
        this.atualizarTituloCard();
        this.transferenciaCaixaPendenteAtualizacao = null;
      } catch (error) {
        // A transferência já foi confirmada; este retry executa somente consultas.
      } finally {
        this.isLoading = false;
      }
    },
    exportarExtratoXLS() {
      const dados = this.tableMovimentacoes.map((item) => {
        return {
          "Data/Hora": this.formatDataHoraMovimento(item),
          Tipo: this.tipoMovimento(item),
          Status: this.statusMovimento(item),
          Descrição: this.descricaoApresentacao(item),
          Origem: item.origem ?? "",
          Destino: item.destino ?? "",
          Documento:
            item.documento_conta_receber ?? item.documento_conta_pagar ?? "",
          Histórico:
            item.historico_conta_receber ?? item.historico_conta_pagar ?? "",
          Valor: `${
            Number(item.tipo_movimento) === 1 ? "+" : "-"
          } ${this.numberToReal(item.valor_movimento ?? 0)}`,
          "Saldo após": this.numberToReal(item.saldo_apos ?? 0),
        };
      });

      const ws = XLSX.utils.json_to_sheet(dados);

      // (Opcional) larguras de coluna aproximadas
      ws["!cols"] = [
        { wch: 18 },
        { wch: 14 },
        { wch: 12 },
        { wch: 40 },
        { wch: 24 },
        { wch: 24 },
        { wch: 18 },
        { wch: 35 },
        { wch: 16 },
        { wch: 16 },
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Extrato");

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const nomeArquivo = `extrato_bancario_${
        this.banco?.nome || "banco"
      }.xlsx`;
      saveAs(blob, nomeArquivo);
    },
    editarMovimento(item) {
      if (!this.podeEditarMovimento(item)) return;

      this.lancamento = { ...item };
      this.dataMovimentoOriginalEdicao = item.data_movimento;
      this.lancamento.valor = item.valor_movimento;
      this.lancamento.tipo = item.tipo_movimento;
      this.$root.$emit("bv::toggle::collapse", "sidebar-movimento-fields");
    },
    onPeriodChange() {
      this.reiniciarPaginacao();
      if (this.selectedPeriodo === "personalizado") {
        if (this.periodoPersonalizadoValido()) return this.applyPeriod();
        return;
      }

      return this.applyPeriod();
    },
    onDataPersonalizadaChange() {
      this.reiniciarPaginacao();
      this.selectedPeriodo = "personalizado";
      if (this.periodoPersonalizadoValido()) return this.applyPeriod();
    },
    async salvarTransferencia() {
      if (this.isSavingTransferenciaContas) return;

      if (!this.transferencia.banco) {
        this.$toast.warning("Seleciona a conta para transferência!");
        return;
      }

      const valor = Number(this.transferencia.valor);
      if (!Number.isFinite(valor) || valor <= 0) {
        this.$toast.warning("Informe o valor da transferência!");
        return;
      }

      this.transferencia.data_transferencia =
        this.transferencia.data_transferencia || moment().format("YYYY-MM-DD");

      if (
        this.dataAnteriorAbertura(
          this.transferencia.data_transferencia,
          this.dataMinimaTransferenciaContas
        )
      ) {
        this.$toast.warning(
          "A data da transferência não pode ser anterior à abertura das contas envolvidas."
        );
        return;
      }

      const observacao = (this.transferencia.observacao || "").trim();
      const payload = {
        banco: this.transferencia.banco,
        valor_tranferencia: valor,
        descricao: observacao || "Transferência",
        banco_origem: this.banco.id_banco,
        data_transferencia: this.transferencia.data_transferencia,
      };

      this.isSavingTransferenciaContas = true;
      this.addLoadingToButton("salvarTranferencia");
      let transferenciaConfirmada = false;
      try {
        await this.$http.post("/bancos/transferencia", payload);
        transferenciaConfirmada = true;
        this.$toast.success("Transferência realizada com sucesso!");
        this.transferencia = {
          banco: null,
          valor: 0,
          data_transferencia: moment().format("YYYY-MM-DD"),
          observacao: "",
        };
        await this.carregarBancoEExtrato();
        this.mostrarTransferencia = false;
      } catch (error) {
        if (transferenciaConfirmada) {
          this.$toast.warning(
            "A transferência foi concluída, mas não foi possível atualizar o saldo e o extrato. Atualize a tela."
          );
        } else if (error.response?.status === 422) {
          const errors = error.response?.data?.errors || {};
          this.$toast.warning(
            Object.values(errors).flat().join(" ") ||
              "Verifique os dados da transferência."
          );
        }
      } finally {
        this.isSavingTransferenciaContas = false;
        this.removeLoadingToButton("salvarTranferencia");
      }
    },
    async salvarMovimento() {
      if (!this.banco) {
        this.$toast.warning("Nenhum banco selecionado!");
        return;
      }

      if (this.lancamento.valor <= 0) {
        this.$toast.warning("Informe o valor do movimento!");
        return;
      }

      if (!this.lancamento.tipo) {
        this.$toast.warning("Selecione o tipo do movimento!");
        return;
      }

      const deveValidarData =
        !this.lancamento.id_movimento ||
        this.dataMovimentoFoiAlteradaNaEdicao(this.lancamento.data_movimento);

      if (
        deveValidarData &&
        this.dataAnteriorAbertura(
          this.lancamento.data_movimento,
          this.dataMinimaMovimento
        )
      ) {
        this.$toast.warning(
          this.lancamento.banco_contraparte_id
            ? "A data da transferência não pode ser anterior à abertura das contas envolvidas."
            : "A data da movimentação não pode ser anterior à abertura da conta."
        );
        return;
      }

      this.lancamento.id_banco = this.banco.id_banco;

      this.addLoadingToButton("salvarMovimento");
      let movimentoConfirmado = false;
      try {
        if (this.lancamento.id_movimento) {
          await this.$http.post("/bancos/movimentacao-update", this.lancamento);
          this.$toast.success("Lançamento atualizado com sucesso!");
        }

        if (!this.lancamento.id_movimento) {
          await this.$http.post("/bancos/movimentacao-create", this.lancamento);
          this.$toast.success("Lançamento realizado com sucesso!");
        }
        movimentoConfirmado = true;
        await this.carregarBancoEExtrato();
        this.lancamento = {};
        this.dataMovimentoOriginalEdicao = null;
      } catch (error) {
        if (movimentoConfirmado) {
          this.$toast.warning(
            "A movimentação foi concluída, mas não foi possível atualizar o saldo e o extrato. Atualize a tela."
          );
        }
      }
      this.lancamento = {};
      this.dataMovimentoOriginalEdicao = null;
      this.removeLoadingToButton("salvarMovimento");
      this.$root.$emit("bv::toggle::collapse", "sidebar-movimento-fields");
    },
    periodoPersonalizadoValido() {
      const inicio = moment(this.data_inicial, "YYYY-MM-DD", true);
      const fim = moment(this.data_final, "YYYY-MM-DD", true);

      return inicio.isValid() && fim.isValid() && !inicio.isAfter(fim);
    },
    dataMovimentoFoiAlteradaNaEdicao(novaData) {
      if (!this.dataMovimentoOriginalEdicao) return true;

      return (
        moment(novaData).format("YYYY-MM-DD") !==
        moment(this.dataMovimentoOriginalEdicao).format("YYYY-MM-DD")
      );
    },
    definirDatasPeriodoSelecionado() {
      const currentDate = moment();

      switch (this.selectedPeriodo) {
        case "hoje":
          this.data_inicial = currentDate
            .clone()
            .startOf("day")
            .format("YYYY-MM-DD");
          this.data_final = currentDate
            .clone()
            .endOf("day")
            .format("YYYY-MM-DD");
          break;
        case "ontem":
          this.data_inicial = currentDate
            .clone()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
          this.data_final = currentDate
            .clone()
            .subtract(1, "days")
            .endOf("day")
            .format("YYYY-MM-DD");
          break;
        case "semana":
          this.data_inicial = currentDate
            .clone()
            .subtract(6, "days")
            .format("YYYY-MM-DD");
          this.data_final = currentDate.clone().format("YYYY-MM-DD");
          break;
        case "semana_passada":
          this.data_inicial = currentDate
            .clone()
            .subtract(1, "week")
            .startOf("week")
            .format("YYYY-MM-DD");
          this.data_final = currentDate
            .clone()
            .subtract(1, "week")
            .endOf("week")
            .format("YYYY-MM-DD");
          break;
        case "mes":
          this.data_inicial = currentDate
            .clone()
            .startOf("month")
            .format("YYYY-MM-DD");
          this.data_final = currentDate
            .clone()
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
      }
    },
    atualizarTituloCard() {
      this.titulo_card = `${
        this.banco?.nome || "Conta bancária"
      } - Extrato bancário`;
    },
    applyPeriod() {
      if (!this.selectedPeriodo) return;
      if (this.selectedPeriodo !== "personalizado") {
        this.definirDatasPeriodoSelecionado();
      }
      if (!this.periodoPersonalizadoValido()) return;

      this.atualizarTituloCard();
      return this.filterMovimentacoes();
    },

    async getBanco(id) {
      try {
        const data = await this.carregarBancoAtual();

        this.titulo =
          "Movimentação bancária: " +
          data.nome +
          " " +
          data.agencia +
          "/" +
          data.conta;
      } catch (error) {
        return null;
      }
    },
    async filterMovimentacoes() {
      this.isLoading = true;
      try {
        const { data } = await this.$http.post(
          "/bancos/movimentacoes",
          this.parametrosExtrato()
        );

        this.aplicarRespostaExtrato(data);
      } finally {
        this.isLoading = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
    isSavingTransferencia() {
      return (
        this.isSavingTransferenciaContas || this.isSavingTransferenciaCaixa
      );
    },
    dataMinimaBancoAtual() {
      return this.dataAberturaConta(this.banco);
    },
    dataMinimaTransferenciaContas() {
      return this.dataMaisRecente(
        this.dataMinimaBancoAtual,
        this.dataAberturaConta(this.transferencia.banco)
      );
    },
    dataMinimaTransferenciaAtual() {
      return this.tipoTransferencia === "caixa"
        ? this.dataMinimaBancoAtual
        : this.dataMinimaTransferenciaContas;
    },
    dataMinimaMovimento() {
      const bancoContraparte = this.bancos.find(
        (banco) =>
          Number(banco.id_banco) ===
          Number(this.lancamento.banco_contraparte_id)
      );

      return this.dataMaisRecente(
        this.dataMinimaBancoAtual,
        this.dataAberturaConta(bancoContraparte)
      );
    },
    movimentacoesOrdenadas() {
      return [...this.movimentacoes].sort((a, b) => {
        const comparacaoData = this.dataHoraEfetivaMovimento(a).localeCompare(
          this.dataHoraEfetivaMovimento(b)
        );

        return comparacaoData !== 0
          ? comparacaoData
          : Number(a.id_movimento) - Number(b.id_movimento);
      });
    },
    movimentacoesComSaldo() {
      let saldo = this.saldoBasePeriodo;

      return this.movimentacoesOrdenadas.map((movimento) => {
        const valor = Number(movimento.valor_movimento) || 0;
        saldo += Number(movimento.tipo_movimento) === 1 ? valor : -valor;

        return { ...movimento, saldo_apos: saldo };
      });
    },
    movimentacoesOperacionaisPeriodo() {
      return this.movimentacoesOrdenadas.filter(
        (movimento) => Number(movimento.abertura_conta) !== 1
      );
    },
    resumoExtrato() {
      const saldoAnterior = this.saldoBasePeriodo;
      const entradas = this.movimentacoesOperacionaisPeriodo
        .filter((item) => Number(item.tipo_movimento) === 1)
        .reduce(
          (total, item) => total + (Number(item.valor_movimento) || 0),
          0
        );
      const saidas = this.movimentacoesOperacionaisPeriodo
        .filter((item) => Number(item.tipo_movimento) === 2)
        .reduce(
          (total, item) => total + (Number(item.valor_movimento) || 0),
          0
        );

      return {
        saldoAnterior,
        entradas,
        saidas,
        resultadoPeriodo: entradas - saidas,
        quantidadeEntradas: this.movimentacoesOperacionaisPeriodo.filter(
          (item) =>
            Number(item.tipo_movimento) === 1 &&
            Number(item.valor_movimento) !== 0
        ).length,
        quantidadeSaidas: this.movimentacoesOperacionaisPeriodo.filter(
          (item) =>
            Number(item.tipo_movimento) === 2 &&
            Number(item.valor_movimento) !== 0
        ).length,
      };
    },
    classeResultadoPeriodo() {
      if (this.resumoExtrato.resultadoPeriodo > 0)
        return "resumo-card--entrada";
      if (this.resumoExtrato.resultadoPeriodo < 0) return "resumo-card--saida";

      return "resumo-card--anterior";
    },
    sinalResultadoPeriodo() {
      if (this.resumoExtrato.resultadoPeriodo > 0) return "+";
      if (this.resumoExtrato.resultadoPeriodo < 0) return "-";

      return "";
    },
    periodoFormatado() {
      if (!this.periodoPersonalizadoValido()) return "";

      return `${this.formatDate(this.data_inicial)} a ${this.formatDate(
        this.data_final
      )}`;
    },
    rotuloSaldoAnterior() {
      const dataAnterior =
        this.dataSaldoAnteriorPeriodo ||
        this.movimentacoesOrdenadas[0]?.data_saldo_dia_anterior;
      if (!dataAnterior || !moment(dataAnterior).isValid()) {
        return "Saldo anterior";
      }

      return `Saldo em ${moment(dataAnterior).format("DD/MM/YYYY")}`;
    },
    detalheSaldoFinal() {
      if (!moment(this.data_final, "YYYY-MM-DD", true).isValid()) return "";

      return `Em ${this.formatDate(this.data_final)}`;
    },
    saldoBasePeriodo() {
      if (this.saldoAnteriorPeriodo !== null) {
        return Number(this.saldoAnteriorPeriodo) || 0;
      }

      return this.movimentacoesOrdenadas.length > 0
        ? Number(this.movimentacoesOrdenadas[0].saldo_dia_anterior) || 0
        : 0;
    },
    movimentacoesParaExibicao() {
      return this.movimentacoesComSaldo;
    },
    tableMovimentacoes() {
      const termo = this.buscaMovimento.toLocaleLowerCase("pt-BR");

      return this.movimentacoesParaExibicao.filter((item) => {
        if (
          this.filtroTipo !== "Todos" &&
          this.tipoMovimento(item) !== this.filtroTipo
        )
          return false;
        if (
          this.filtroStatus !== "Todos" &&
          this.statusMovimento(item) !== this.filtroStatus
        )
          return false;
        if (!termo) return true;

        return [
          this.descricaoApresentacao(item),
          item.documento_conta_receber,
          item.documento_conta_pagar,
          item.historico_conta_receber,
          item.historico_conta_pagar,
          item.origem,
          item.destino,
        ].some((valor) =>
          String(valor || "")
            .toLocaleLowerCase("pt-BR")
            .includes(termo)
        );
      });
    },
    totalPaginas() {
      return Math.max(
        1,
        Math.ceil(this.tableMovimentacoes.length / this.porPagina)
      );
    },
    movimentacoesPaginadas() {
      const inicio = (this.paginaAtual - 1) * this.porPagina;

      return this.tableMovimentacoes.slice(inicio, inicio + this.porPagina);
    },
    primeiroRegistroPagina() {
      return this.tableMovimentacoes.length === 0
        ? 0
        : (this.paginaAtual - 1) * this.porPagina + 1;
    },
    ultimoRegistroPagina() {
      return Math.min(
        this.paginaAtual * this.porPagina,
        this.tableMovimentacoes.length
      );
    },
    itensTabelaExtrato() {
      const saldosFechamento = this.movimentacoesComSaldo.reduce(
        (saldos, movimento) => {
          const dataMovimento = moment(
            this.dataHoraEfetivaMovimento(movimento)
          );
          if (dataMovimento.isValid()) {
            saldos.set(
              dataMovimento.format("YYYY-MM-DD"),
              movimento.saldo_apos
            );
          }

          return saldos;
        },
        new Map()
      );
      const indicesMovimentos = new Map(
        this.tableMovimentacoes.map((movimento, index) => [
          movimento.id_movimento,
          index,
        ])
      );

      return this.movimentacoesPaginadas.reduce((linhas, movimento) => {
        const dataMovimento = moment(this.dataHoraEfetivaMovimento(movimento));
        const indiceMovimento = indicesMovimentos.get(movimento.id_movimento);
        const movimentoSeguinte =
          this.tableMovimentacoes[indiceMovimento + 1] || null;
        const dataMovimentoSeguinte = movimentoSeguinte
          ? moment(this.dataHoraEfetivaMovimento(movimentoSeguinte))
          : null;
        const terminaDia =
          dataMovimento.isValid() &&
          (!dataMovimentoSeguinte ||
            !dataMovimentoSeguinte.isValid() ||
            !dataMovimento.isSame(dataMovimentoSeguinte, "day"));

        linhas.push(movimento);

        if (terminaDia) {
          const chaveData = dataMovimento.format("YYYY-MM-DD");
          linhas.push({
            id_movimento: `saldo-${chaveData}`,
            eh_fechamento_diario: true,
            descricao: `Saldo em ${dataMovimento.format("DD/MM/YYYY")}`,
            saldo_apos: saldosFechamento.get(chaveData),
          });
        }

        return linhas;
      }, []);
    },
  },
  async mounted() {
    window.addEventListener("resize", this.atualizarAlturaUtilExtrato);
    this.atualizarAlturaUtilExtrato();
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    const currentDate = moment();
    const monthStart = currentDate
      .clone()
      .startOf("month")
      .format("YYYY-MM-DD");
    const monthEnd = currentDate.clone().endOf("month").format("YYYY-MM-DD");

    this.data_inicial = monthStart;
    this.data_final = monthEnd;

    await this.getBanco(this.$route.params.id_banco);
    this.atualizarTituloCard();

    await this.filterMovimentacoes();

    this.bancos = await this.getBancosByEmpresa();
    this.atualizarAlturaUtilExtrato();
  },
  beforeDestroy() {
    clearTimeout(this.debounceBuscaTimer);
    window.removeEventListener("resize", this.atualizarAlturaUtilExtrato);
  },
};
